import React from 'react';
import { DisabledAdsWarningContainer } from 'components/AdInsertion/styles';

export const ENABLE_PAYWALLS_DISABLED_ADS_WARNING = true;

export function AdInsertionPaywallDisabledAdsWarning({
  isPWEpisode,
  hasAdCuePoints,
  hasAdSegments,
}: {
  isPWEpisode?: boolean;
  hasAdCuePoints: boolean;
  hasAdSegments: boolean;
}) {
  const hasAds = hasAdCuePoints || hasAdSegments;
  if (!isPWEpisode || !hasAds) return null;
  return (
    <DisabledAdsWarningContainer>
      <p>Ads by Anchor features will be disabled for subscription episodes.</p>
    </DisabledAdsWarningContainer>
  );
}
